import { FunctionComponent } from 'react';
import styles from './Metrics.module.scss';
import clsx from 'clsx';
import { Metric as MetricModel } from '@spike/appointments-list-model';
import Metric from './Metric';

interface MetricsProps {
    metrics: Array<MetricModel>;
    loading?: boolean;
    className?: string;
}

export const Metrics: FunctionComponent<MetricsProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            {props.metrics
                .map(metric => (metric.label.toLowerCase() === 'adr' ? { ...metric, label: 'ADR' } : metric))
                .map(metric => (
                    <Metric
                        key={metric.key}
                        data={metric}
                        loading={props.loading}
                    />
                ))}
        </div>
    );
};

export default Metrics;
